import { createAction, createReducer, on, props } from '@ngrx/store';
import { config } from '../../config/config';

/**
 * Init default config state
 */
export const initialState = config;

/**
 * Update action
 */
export const setConfig = createAction(
  '[Config] Set Config',
  props<{ langs: any[]; allLangs: any[] }>()
);

/**
 * Config reducer
 */
const _configReducer = createReducer(
  initialState,
  on(setConfig, (state, { langs, allLangs }) => ({
    apiUrl: state.apiUrl,
    sidebarRoutes: state.sidebarRoutes,
    languages: langs,
    allLanguages: allLangs,
    static: state.static,
  }))
);

export function configReducer(state: any, action: any) {
  return _configReducer(state, action);
}
